import React from 'react';

/**
 * Resize handles for all 8 directions (4 edges + 4 corners)
 * 
 * Uses --inverse-zoom CSS variable for instant zoom-independent sizing.
 * No React prop needed - CSS handles the scaling directly.
 * 
 * ═══════════════════════════════════════════════════════════════════════════════
 * DISABLED: 2026-01-27
 * Manual card resizing has been disabled because custom sizes would get "burned in"
 * and prevent cards from auto-sizing when card display fields are toggled on/off.
 * This caused content to overflow card boundaries.
 * 
 * The component now renders nothing. To re-enable, uncomment the code below.
 * ═══════════════════════════════════════════════════════════════════════════════
 */

// const DIRECTIONS = ['n', 's', 'w', 'e', 'nw', 'ne', 'sw', 'se'];

const ResizeHandles = ({ onResizeMouseDown }) => {
  // DISABLED: Manual resize feature removed 2026-01-27
  // Cards now auto-size based on content and card display settings
  return null;
  
  /* Original implementation:
  return (
    <>
      {DIRECTIONS.map(dir => (
        <div 
          key={dir}
          className={`task-node__resize-handle task-node__resize-handle--${dir}`}
          onMouseDown={(e) => onResizeMouseDown(e, dir)}
        />
      ))}
    </>
  );
  */
};

export default ResizeHandles;

